import { useHasInitProfile } from '~/composables/useHasInitProfile';
import { useVerifiedSupabaseUser } from '~/composables/useVerifiedSupabaseUser';
import { useProfileQuery } from '~/queries/useProfileQuery';

export default defineNuxtPlugin({
	name: 'demo-mode',
	dependsOn: ['vue-query', 'supabase'],
	setup: () => {
		const user = useVerifiedSupabaseUser();
		const hasInitProfile = useHasInitProfile();

		const isLoggedInAndConfirmed = computed(() => !!user.value && user.value.is_anonymous !== true);

		const { data: profile } = useProfileQuery({ enabled: isLoggedInAndConfirmed, ignoreSentry: toRef(() => !hasInitProfile.value) });

		const isDemo = useState<boolean>('demo-mode', () => false);

		watch(profile, (_profile) => {
			if (_profile) {
				isDemo.value = _profile.useDemoReporting;
			}
		});

		return {
			provide: {
				isDemo: readonly(isDemo),
			},
		};
	},
});
